import { useMemo } from "react";
import Card from "../../../../components/card/card";
import type { PageTabsProps } from "../../../../components/page-tabs/page-tabs.types";
import ChatModule from "../chat-module/chat-module";
import PollsModule from "../polls-module/polls-module";
import * as CSS from "./interactions-module.styles";

const InteractionsModule = () => {
	const pages: PageTabsProps[] = useMemo(
		() => [
			{
				id: "comments",
				title: "Comments",
				children: <ChatModule />,
			},
			{
				id: "polls",
				title: "Polls",
				children: <PollsModule />,
			},
		],
		[],
	);

	return (
		<CSS.InteractionsModule>
			<Card pages={pages} />
		</CSS.InteractionsModule>
	);
};

export default InteractionsModule;
